import styled from 'styled-components';
export const PriceStyles = styled.div `
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 0 4px;
`;
